import { httpService } from '../../../http-service/httpService';
import {
  CERTS_EXPORT_APPLY_FILTER,
  CERTS_EXPORT_COLUMNS_TO_EXPORT,
  CERTS_EXPORT_STATUS,
  GET_CERTS_DETAILS_FOR_EXPORT,
  SET_CERTS_EXPORT_IS_LOADING,
} from '../types';
import {
  URL_EXPORT_NEW_API,
  URL_EXPORT_OLD_API,
  URL_GET_APPLIED_COLUMNS_FOR_EXPORT,
} from '../urls';

export const setCertsExportStatus = (payload) => (dispatch) => {
  dispatch({
    type: CERTS_EXPORT_STATUS,
    payload,
  });
};

export const certsExportApplyFilter = (payload) => (dispatch) => {
  dispatch({
    type: CERTS_EXPORT_APPLY_FILTER,
    payload,
  });
};

export const certsExportColumnsToExport = (payload) => (dispatch) => {
  dispatch({
    type: CERTS_EXPORT_COLUMNS_TO_EXPORT,
    payload,
  });
};

export const setCertsExportIsLoading = (payload) => (dispatch) => {
  dispatch({
    type: SET_CERTS_EXPORT_IS_LOADING,
    payload,
  });
};

export const performCertsExport =
  (certkey, columnsToExport, applyFilter, searchText) => async (dispatch) => {
    const exportColumns = {};
    // to remove the spaces between column names

    if (columnsToExport && typeof columnsToExport === 'object') {
      Object.keys(columnsToExport).forEach((k) => {
        exportColumns[k.replace(/\s+/g, '')] = columnsToExport[k];
      });
    }

    const body = {
      certkey,
      columnsToExport: exportColumns,
      neoExport: true,
      applyFilter,
      sSearch: applyFilter ? searchText : '',
    };

    dispatch(setCertsExportIsLoading(true));

    try {
      // using certms url when user wants to export applied filters
      if (applyFilter) {
        const getAppliedFiltersResponse = await httpService.post(
          URL_GET_APPLIED_COLUMNS_FOR_EXPORT,
          { certkey }
        );

        if (getAppliedFiltersResponse?.status === 200) {
          body.isFilterJsonFromCertMs = '1';
          body.filterjson = getAppliedFiltersResponse?.data || {};
        }
      }

      const response = await httpService.post(
        URL_EXPORT_NEW_API,
        body,
        // Prevent axios from automatically throwing on 412
        {
          validateStatus: (status) => status === 200 || status === 412,
        }
      );

      if (response?.status === 200) {
        dispatch(
          setCertsExportStatus({
            exportStatus: 'SUCCESS',
            timeStamp: Date.now(),
          })
        );

        return { success: true };
      }

      if (response?.status === 412) {
        dispatch(
          setCertsExportStatus({
            exportStatus: 'FAILED-412',
            timeStamp: Date.now(),
          })
        );

        return { success: true };
      }

      return { success: false };
    } catch (error) {
      dispatch(
        setCertsExportStatus({ exportStatus: 'FAILED', timeStamp: Date.now() })
      );

      return { success: false };
    } finally {
      dispatch(setCertsExportIsLoading(false));
    }
  };

export const getCertDetailsForExport =
  (certKey, columnNames, max, offset, searchText = '') =>
  async (dispatch, getState) => {
    const {
      viewControls: { groupBy },
    } = getState().certifications.details;
    const selectedGroupByValue = groupBy?.find(
      (option) => option.isChecked
    )?.value;

    const body = {
      certkey: certKey,
      max: `${max}`,
      offset: `${offset}`,
      requestOrigin: 'UI',
      sSearch: `${searchText}`,
      columnsToShow: columnNames,
      tab: 'all',
      group_by: selectedGroupByValue,
    };

    try {
      const { data } = await httpService.post(URL_EXPORT_OLD_API, body);

      const { total } = data;

      dispatch({
        type: GET_CERTS_DETAILS_FOR_EXPORT,
        payload: total,
      });
    } catch (error) {
      dispatch({
        type: GET_CERTS_DETAILS_FOR_EXPORT,
        payload: null,
      });
    }
  };
